import { SalesPackTabModel } from '@/types';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';

export const AutomotiveSalesPackTab = {
  methods: {
    validateSalesPackDocuments(salesPackDocuments: SalesPackTabModel[]): boolean {
      salesPackDocuments = salesPackDocuments.filter((x) => x.comments === 'No document available');
      if (salesPackDocuments.length > 0) {
        SnotifyConfiguration.showInformation('No related documents available for document type(s): ' + salesPackDocuments.map((x) => x.mstoreRowName));
        return false;
      }
      return true;
    }
  }
};
